var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text paddingSize",style:({
		marginTop: _vm.data.marginTop + 'px',
		paddingTop: _vm.data.paddingTop + 'px',
		backgroundColor: _vm.data.backgroundColor,
		paddingLeft: _vm.data.paddingLeft + '%',
		paddingRight: _vm.data.paddingRight + '%',
	})},[(_vm.data.content)?_c('p',{staticClass:"textInfo",style:({
			color: _vm.data.textColor,
			fontSize: _vm.data.fontSize + 'px',
			fontWeight: _vm.data.fontWeight,
			lineHeight: _vm.data.fontLineHeight + 'px',
			textAlign: _vm.data.textAlign,
		})},[_vm._v(" "+_vm._s(_vm.data.content)+" ")]):_c('div',{staticClass:"textInfo"},[_vm._v("默认文字")])])}
var staticRenderFns = []

export { render, staticRenderFns }